import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useIsMobile from '../hooks/useIsMobile';
import api from '../services/api';

function SaldoExito() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [searchParams] = useSearchParams();
  const [verificando, setVerificando] = useState(true);
  const [recarga, setRecarga] = useState(null);

  useEffect(() => { verificarRecarga(); }, []);

  const verificarRecarga = async () => {
    const recargaId = searchParams.get('recarga_id');
    if (recargaId) {
      try {
        const response = await api.get(`/pagos/verificar/${recargaId}`);
        setRecarga(response.data);
      } catch (error) { console.error('Error:', error); }
    }
    setVerificando(false);
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: isMobile ? '1rem' : '0' }}>
      <div style={{ backgroundColor: 'white', borderRadius: '1rem', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', padding: isMobile ? '2rem 1.5rem' : '3rem', textAlign: 'center', maxWidth: '400px', width: '100%' }}>
        <div style={{ fontSize: isMobile ? '3rem' : '4rem', marginBottom: '1rem' }}>&#x2705;</div>
        <h1 style={{ fontSize: isMobile ? '1.25rem' : '1.5rem', fontWeight: 'bold', color: '#065f46', marginBottom: '1rem' }}>
          Pago Exitoso!
        </h1>
        {recarga && (
          <p style={{ fontSize: isMobile ? '1rem' : '1.25rem', color: '#374151', marginBottom: '1rem' }}>
            Se han agregado <strong style={{ color: '#ff8c00' }}>${parseFloat(recarga.monto).toFixed(2)} MXN</strong> a tu saldo
          </p>
        )}
        <p style={{ color: '#6b7280', marginBottom: '2rem', fontSize: isMobile ? '0.875rem' : '1rem' }}>
          Tu saldo ha sido actualizado y ya puedes crear envios.
        </p>
        <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '0.75rem', justifyContent: 'center' }}>
          <button onClick={() => navigate('/saldo')} style={{
            padding: '0.75rem 1.5rem', backgroundColor: '#ff8c00', color: 'white', border: 'none',
            borderRadius: '0.375rem', fontWeight: '600', cursor: 'pointer', fontSize: '0.9rem'
          }}>Ver Mi Saldo</button>
          <button onClick={() => navigate('/crear-envio')} style={{
            padding: '0.75rem 1.5rem', backgroundColor: 'white', color: '#ff8c00', border: '2px solid #ff8c00',
            borderRadius: '0.375rem', fontWeight: '600', cursor: 'pointer', fontSize: '0.9rem'
          }}>Crear Envio</button>
        </div>
      </div>
    </div>
  );
}

export default SaldoExito;
